import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

/**
 * Interceptor to add JWT token to API requests
 */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);

  // Only add token to API requests (not for i18n files)
  const isApiRequest =
    req.url.includes('localhost:8080') ||
    req.url.includes('b.stefconnect-dev.stef.com') ||
    req.url.includes('b.stefconnect-qua.stef.com') ||
    req.url.includes('b.stefconnect.stef.com');

  if (!isApiRequest) {
    return next(req);
  }

  const token = authService.getToken();

  if (!token) {
    return next(req);
  }

  // Clone the request and add the Authorization header
  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(clonedRequest);
};
